export const areLeadMagnetsEnabled = () =>
  process.env.REACT_APP_ENABLE_LEAD_MAGNETS === "true";
